import { Language } from '../i18n/LanguageStore';

const numericRegExp = /^(\d+)(?!\D)$/;

export const isStrictlyNumeric = (str: string) => numericRegExp.test(str);

const getLastIdxSummary = (value: string, lang: Language): string =>
  lang === Language.ENGLISH ? `, and ${value}` : ` og ${value}`;

export const formatToSummaryString = (
  strings: string[],
  lang: Language,
): string => {
  if (strings.length === 0) {
    return '';
  }

  const firstStringRemovedList = strings.slice(1);
  const lastIndex = firstStringRemovedList.length - 1;

  return firstStringRemovedList.reduce((acc, value, index) => {
    if (index === lastIndex) {
      return acc.concat(getLastIdxSummary(value, lang));
    }

    return acc.concat(`, ${value}`);
  }, strings[0]); // Init value is set to first string of main array
};

export const overflowEllipsis = (str: string, maxChars: number): string =>
  str.length >= maxChars ? str.slice(0, maxChars - 1).concat('...') : str;

export const mapUndefinedToEmptyString = (
  ...stringsOrUndefined: (string | undefined)[]
): string[] => stringsOrUndefined.map((str) => str || '');
